import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

import type { Direction } from '@mui/material';

export const useCacheByDirection = (direction: Direction = 'ltr') =>
  createCache(
    direction === 'rtl'
      ? { key: 'muiltr', stylisPlugins: [prefixer, rtlPlugin] }
      : { key: 'default' },
  );
